import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { useTranslation } from "react-i18next"
import {
  BackofficeShopifyMetafieldsAuditBodySchema,
  BackofficeShopifyMetafieldsAuditResponseDataSchema,
  DataResponse,
} from "schema"
import { toast } from "sonner"
import { z } from "zod"

type Props = z.input<typeof BackofficeShopifyMetafieldsAuditBodySchema>
type Response = DataResponse<z.infer<typeof BackofficeShopifyMetafieldsAuditResponseDataSchema>>

export function useRequestShopifyMetafieldsAuditMutation() {
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (props: Props) => {
      const response = await axios.post<Response>("/backoffice/shopifyMetafieldsAudit", props)

      return response.data.data
    },
    onSuccess: () => {
      toast.success(t("backoffice.shopifyMetafieldsAudit.requestSuccess"))
    },
  })
}
